import { render, staticRenderFns } from "./ToupingNewHg.vue?vue&type=template&id=2b8a5a1d&scoped=true"
import script from "./ToupingNewHg.vue?vue&type=script&lang=js"
export * from "./ToupingNewHg.vue?vue&type=script&lang=js"
import style0 from "./ToupingNewHg.vue?vue&type=style&index=0&id=2b8a5a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8a5a1d",
  null
  
)

export default component.exports